/**
 * PRX-30: Fillware labels every scanned attachment with a free-text `Comment`
 * chosen at scan time — system kinds are wrapped in tildes ("~DOCTOR'S RX~",
 * "~HARD COPY~"), user kinds are plain ("VACATION FORM", "FAX TO MD",
 * "MI CODE USED"). PHOX used to show every one of them as "Script Image", so a
 * second document looked like it had replaced the prescription.
 *
 * Turns that comment into a tab label: tildes stripped, sentence case, the
 * pharmacy acronyms kept. Placeholders ("~NO NOTE~", "No Description") yield
 * null so the caller falls back to its type-based label.
 */
const PLACEHOLDERS = new Set(['', 'no note', 'no description', 'other']);

const ACRONYMS: Record<string, string> = {
  rx: 'Rx',
  md: 'MD',
  mi: 'MI',
  bp: 'BP',
  odb: 'ODB',
  mrx: 'MRx',
};

export function humanizeAttachmentLabel(raw?: string | null): string | null {
  if (!raw) return null;
  const cleaned = raw.replace(/~/g, '').replace(/\s+/g, ' ').trim();
  if (PLACEHOLDERS.has(cleaned.toLowerCase())) return null;

  const words = cleaned.toLowerCase().split(' ');
  const cased = words.map((word, index) => {
    // "doctor's" / "rx/authorization" — case each alphabetic run independently
    const casedRun = word.replace(/[a-z]+/g, (run) => {
      if (ACRONYMS[run]) return ACRONYMS[run];
      return index === 0 && word.startsWith(run) ? run.charAt(0).toUpperCase() + run.slice(1) : run;
    });
    return casedRun;
  });
  const label = cased.join(' ');
  return label.charAt(0).toUpperCase() + label.slice(1);
}
